// extracted by mini-css-extract-plugin
module.exports = {"dots":"SliderDots_dots__vvWtN","dot":"SliderDots_dot__ExCbA","sm":"SliderDots_sm__Vngck","md":"SliderDots_md__y87dn","active":"SliderDots_active__4virr"};